import { throwError, timer } from "rxjs";
import { mergeMap, finalize } from "rxjs/operators";
const genericRetryStrategy = ({
  maxRetryAttempts = 50,
  scalingDuration = 100,
  excludedStatusCodes = []
} = {}) => (attempts) => attempts.pipe(
  mergeMap((error, i) => {
    const retryAttempt = i + 1;
    if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find((e) => e === error.status)) {
      return throwError(error);
    }
    console.log(
      `#!!!Attempt ${retryAttempt}: retrying in ${retryAttempt * scalingDuration}ms`
    );
    return timer(retryAttempt * scalingDuration);
  }),
  finalize(() => console.log("We are done!"))
);
export {
  genericRetryStrategy
};
